module.exports = __webpack_public_path__ + "assets/img/36_558_big.887a639c.jpg";